/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAppointmentRequestDto
 */
export interface CreateAppointmentRequestDto {
    /**
     * Provider ID
     * @type {string}
     * @memberof CreateAppointmentRequestDto
     */
    providerId?: string;
    /**
     * Patient ID
     * @type {string}
     * @memberof CreateAppointmentRequestDto
     */
    patientId: string;
    /**
     * Color code
     * @type {number}
     * @memberof CreateAppointmentRequestDto
     */
    colorCode?: number;
    /**
     * Start time in ISO 8601 format (UTC)
     * @type {Date}
     * @memberof CreateAppointmentRequestDto
     */
    startTime: Date;
    /**
     * End time in ISO 8601 format (UTC)
     * @type {Date}
     * @memberof CreateAppointmentRequestDto
     */
    endTime: Date;
    /**
     * Notes
     * @type {string}
     * @memberof CreateAppointmentRequestDto
     */
    notes?: string;
}

/**
 * Check if a given object implements the CreateAppointmentRequestDto interface.
 */
export function instanceOfCreateAppointmentRequestDto(value: object): value is CreateAppointmentRequestDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    return true;
}

export function CreateAppointmentRequestDtoFromJSON(json: any): CreateAppointmentRequestDto {
    return CreateAppointmentRequestDtoFromJSONTyped(json, false);
}

export function CreateAppointmentRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAppointmentRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'providerId': json['providerId'] == null ? undefined : json['providerId'],
        'patientId': json['patientId'],
        'colorCode': json['colorCode'] == null ? undefined : json['colorCode'],
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CreateAppointmentRequestDtoToJSON(json: any): CreateAppointmentRequestDto {
    return CreateAppointmentRequestDtoToJSONTyped(json, false);
}

export function CreateAppointmentRequestDtoToJSONTyped(value?: CreateAppointmentRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'providerId': value['providerId'],
        'patientId': value['patientId'],
        'colorCode': value['colorCode'],
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
        'notes': value['notes'],
    };
}

